<template>
  <div>
    <div class="login-wrapper">
      <div class="login">
        <p class="title">点餐系统(总部)</p>
        <el-form
          :model="user"
          status-icon
          :rules="rules"
          ref="user"
          label-width="0"
          class="demo-ruleForm"
        >
          <el-form-item prop="account">
            <el-input v-model="user.account" auto-complete="off" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="user.password" auto-complete="off" placeholder="输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="login('user')" style="width:100%;">登录</el-button>
            <!--<p class="register" @click="gotoRegist">没有账户？立即注册</p>-->
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'

export default {
  name: 'Login',
  components: {
  },
  data() {
    let checkAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    let validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"))
      } else {
        callback()
      }
    }
    return {
      user: {
        account: '',
        password: ''
      },
      rules: {
        account: [{ validator: checkAccount, trigger: 'change' }],
        password: [{ validator: validatePassword, trigger: 'change' }],
      }
    }
  },
  mounted () {
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var that = this;
          that.$api.post('/main_store/login', that.user, response => {
            if (response.status >= 200 && response.status < 300) {
              console.log(response.data);
              var res = response.data;
              if (res.code == 0) {
                this.$message({
                  message: '登录成功',
                  type: 'success'
                });
                console.log(res.data);
                var storage = window.localStorage;
                storage["access_token"] = res.data.user.user.accessToken;
                storage["user"] = JSON.stringify(res.data.user);
                this.$router.push('/mainStore/index');
              }else{
                this.$message({
                  message: res.msg,
                  type: 'warning'
                });
              }
            } else {
              this.$message({
                message: "服务器维护中",
                type: 'error'
              });
            }

          });
        }
      })
    },
    gotoRegist () {
      this.$router.push({
        path: '/register'
      })
    }
  }
}
</script>
<style scoped>
.loading-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: #aedff8;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background:url("../../assets/images/bg-img-1.jpg")
}
.login-wrapper img {
  position: absolute;
  z-index: 8;
}
.login {
  max-width: 340px;
  margin: 120px auto;
  background: #fff;
  padding: 20px 40px;
  border-radius: 10px;
  position: relative;
  z-index: 9;
}
.title {
  font-size: 26px;
  line-height: 50px;
  font-weight: bold;
  margin: 10px;
  text-align: center;
}
#login-form>input {
  width: 100%;
  height: 34px;
  display: block;
  margin-top: 26px;
  background: #fff;
  color: #333;
  border: 1px solid #7da9c7;
  outline: none;
  text-indent: 20px;
  font-size: 14px;
}
#login-form>button {
  width: 100%;
  height: 34px;
  display: block;
  margin-top: 26px;
  background: #1ab2ff;
  color: #fff;
  border: 1px solid #1ab2ff;
  outline: none;
  border-radius: 100px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}
.register {
  margin-top: 10px;
  font-size: 14px;
  line-height: 22px;
  text-indent: 8px;
  color: #1ab2ff;
  cursor: pointer;
  display: inline-block;
}
.register:hover {
  color: #2c2fd6;
}
@media (max-width: 768px) {
  .login {
    max-width: 260px;
    margin: 60px auto;
    background: #fff;
    padding: 20px 20px;
    border-radius: 10px;
    position: relative;
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mainStore/Login.vue